//@ts-check
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs'
import React from 'react'
import styles from "./InteractiveDialog.module.css"
import ButtonHLPure from '../buttonHL/buttonHL.pure';

/**
 * @typedef {object} Props
 * @property {() => void} [onClose] - Callback function to handle dialog close
 * @property {import('react').MouseEventHandler<HTMLButtonElement>} [onSave] - Callback function to handle dialog save
 * @property {string} [saveBtnTitle] - Title for the save button (default: 'Save')
 * @property {string} [cancelBtnTitle] - Title for the cancel button (default: 'Cancel')
 * @property {React.ReactNode} children - The content to be displayed inside the dialog
 * @property {string} title - Title of the dialog
 * @property {string} [buttonClassname] - Custom class name for the buttons
 * @property {React.ReactNode} [CustomButtons] - Custom buttons to be displayed in the dialog actions bar 
 * @property {'S' | 'M' | 'G' | 'XG'} [dialogSize] - Size of the dialog (default: 'S')
*/

const DIALOG_SIZES = {
    S: 580,
    M: 780,
    G: 1080,
    XG: 1290
}

/**
 * @param {import('@progress/kendo-react-dialogs').DialogProps & Props} props
 */
const InteractiveDialog = ({
    onSave,
    onClose,
    title,
    children,
    saveBtnTitle,
    CustomButtons,
    cancelBtnTitle,
    buttonClassname,
    dialogSize = 'S',
    ...props
}) => {

    const width = DIALOG_SIZES[dialogSize] ?? DIALOG_SIZES.S

    return (
        <>
            <Dialog
                className={styles[`InteractiveDialog-container`]}
                width={width}
                height={'auto'}
                title={title}
                onClose={onClose}
                {...props}
            >
                <div className={styles['InteractiveDialog-content']}>
                    {children}
                </div>
                {(CustomButtons || cancelBtnTitle || saveBtnTitle) && (
                    <DialogActionsBar>
                        <div className={!buttonClassname ? styles["InteractiveDialog-actions"] : buttonClassname}>
                            {CustomButtons ? (
                                <>
                                    {CustomButtons}
                                </>
                            ) : (
                                <>
                                    {cancelBtnTitle && <ButtonHLPure nameBtn={cancelBtnTitle} onClickBtn={onClose} />}
                                    {saveBtnTitle && <ButtonHLPure nameBtn={saveBtnTitle} primary onClickBtn={onSave} />}
                                </>
                            )}
                        </div>
                    </DialogActionsBar>
                )}
            </Dialog>
        </>
    )
}

export default InteractiveDialog